import React from "react";
import './signup.css';
import {Link} from "react-router-dom";
import {SiYourtraveldottv} from "react-icons/si"
import { MdMarkEmailRead } from "react-icons/md";
import { FaUserShield } from "react-icons/fa6";
import { BsFillShieldLockFill } from "react-icons/bs";
import { AiOutlineSwapRight } from "react-icons/ai";


import video from '../../assets/loginAssets/outhouse.mp4'

const SignUp = () => {
    return (
      <div className="backgroundImg">
        <div className="SignupPage flex">
          <div className="container flex">
            <div className="videoDiv">
              <video src={video} autoPlay muted loop></video>
              <div className="textDiv">
                <h2 className="title">Plan your travel with Happy Safar</h2>
                <p>Sign in to continue planning your trip.</p>
              </div>
              <div className="footerDiv">
                <span className="text">Have an account?</span>
                <Link to={'/Login'}>
                <button className="btn btn-primary">Login</button>
                </Link>
              </div>
            </div>
            <div className="formDiv flex">
              <div className="logoDiv">
                <a href="/" className="logo">
                  <h1 className='flex'><SiYourtraveldottv className="logoIcon"/>Happy Safar</h1>
                </a>
              </div>
              <h3>Create Your Account With Us!</h3>
              <form className="form grid">
                <div className="inputDiv">
                  <label htmlFor="email">Email Address</label>
                  <div className="input flex">
                    <MdMarkEmailRead className='icon'/>
                    <input type="email" id="email" name="email" placeholder='Enter Email' required/>
                  </div>
                </div>
                <div className="inputDiv">
                <label htmlFor="username">Username</label>
                  <div className="input flex">
                    <FaUserShield className='icon'/>
                    <input type="username" id="username" name="username" placeholder='Enter Username' required/>
                  </div>
                </div>
                <div className="inputDiv">
                  <label htmlFor="password">Password</label>
                  <div className="input flex">
                    <BsFillShieldLockFill className='icon'/>
                    <input type="password" id="password" name="password" placeholder='Enter Password' required/>
                  </div>
                </div>
                <div className="inputDiv">
                  <label htmlFor="password">Password</label>
                  <div className="input flex">
                    <BsFillShieldLockFill className='icon'/>
                    <input type="password" id="password" name="password" placeholder='Confirm Password' required/>
                  </div>
                </div>
                <Link to={'/'}>
                  <button type='submit' className='btn flex'>
                    <span>Login</span>
                    <AiOutlineSwapRight className='icon'/>
                  </button>
                </Link>
              </form>
            </div>
          </div>
        </div>
      </div>
      )
}

export default SignUp